import styled from 'styled-components';

export const CancelAnchor = styled.a`
  font-size: 1.2rem;
  color: ${props => props.theme.colors.hero.cranberry};

  &:hover {
    text-decoration: underline;
  }
`;
